export function createPortalsPlaceholders() {
  const closeDesktop = document.createElement('div');
  closeDesktop.setAttribute('class', 'ebx-header-close');
  setTimeout(() => {
    const logoContainer = document.querySelector('.logo-container');
    if (logoContainer) {
      logoContainer.appendChild(closeDesktop);
    }
  }, 2000);
}
